package org.solyton.solawi.bid.application.`data`

import kotlin.Int
import kotlin.collections.List
import org.evoleq.axioms.definition.ReadOnly
import org.evoleq.axioms.definition.ReadWrite
import org.evoleq.compose.modal.Modals
import org.evoleq.device.`data`.Device
import org.evoleq.ktorx.api.Api
import org.evoleq.optics.lens.Lens
import org.evoleq.optics.storage.MutableSharedFlowActionDispatcher
import org.solyton.solawi.bid.application.`data`.env.Environment
import org.solyton.solawi.bid.application.`data`.ui.UiStates
import org.solyton.solawi.bid.application.`data`.version.full.FullVersionInfo
import org.solyton.solawi.bid.module.application.`data`.organizationrelation.ApplicationOrganizationRelation
import org.solyton.solawi.bid.module.application.`data`.userapplication.UserApplications
import org.solyton.solawi.bid.module.banking.`data`.bankaccount.BankAccount
import org.solyton.solawi.bid.module.banking.`data`.creditor.identifier.CreditorIdentifier
import org.solyton.solawi.bid.module.banking.`data`.fiscalyear.FiscalYear
import org.solyton.solawi.bid.module.banking.`data`.legalentity.LegalEntity
import org.solyton.solawi.bid.module.banking.`data`.sepa.SepaModule
import org.solyton.solawi.bid.module.bid.`data`.auction.Auction
import org.solyton.solawi.bid.module.bid.`data`.bidder.BidderMails
import org.solyton.solawi.bid.module.bid.`data`.bidround.BidRound
import org.solyton.solawi.bid.module.context.`data`.Context
import org.solyton.solawi.bid.module.cookie.`data`.CookieDisclaimer
import org.solyton.solawi.bid.module.distribution.`data`.distributionpoint.DistributionPoint
import org.solyton.solawi.bid.module.i18n.`data`.I18N
import org.solyton.solawi.bid.module.permissions.`data`.Permissions
import org.solyton.solawi.bid.module.permissions.`data`.relations.ContextRelation
import org.solyton.solawi.bid.module.process.`data`.processes.Processes
import org.solyton.solawi.bid.module.shares.`data`.history.ShareSubscriptionStatusHistories
import org.solyton.solawi.bid.module.shares.`data`.offers.ShareOffer
import org.solyton.solawi.bid.module.shares.`data`.subscriptions.ShareSubscription
import org.solyton.solawi.bid.module.shares.`data`.types.ShareType
import org.solyton.solawi.bid.module.user.`data`.managed.ManagedUser
import org.solyton.solawi.bid.module.user.`data`.user.User

/**
 * Autogenerated ReadOnly Lens.
 * Read [Application.environment]
 */
@ReadOnly
public val environment: Lens<Application, Environment> by lazy {
      Lens(
        get = { whole -> whole.environment },
        set = { { it } }
      )}


/**
 * Autogenerated Lens.
 * Read and manipulate [Application.versionInfo]
 */
@ReadWrite
public val versionInfo: Lens<Application, FullVersionInfo> by lazy {
      Lens(
        get = { whole -> whole.versionInfo },
        set = { part -> { whole -> whole.copy(versionInfo = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.versionInfo]
 */
@ReadWrite
public fun Application.versionInfo(`set`: FullVersionInfo.() -> FullVersionInfo): Application =
    copy(versionInfo = set(versionInfo))

/**
 * Autogenerated ReadOnly Lens.
 * Read [Application.api]
 */
@ReadOnly
public val api: Lens<Application, Api> by lazy {
      Lens(
        get = { whole -> whole.api },
        set = { { it } }
      )}


/**
 * Autogenerated ReadOnly Lens.
 * Read [Application.actions]
 */
@ReadOnly
public val actions: Lens<Application, MutableSharedFlowActionDispatcher<Application>> by lazy {
      Lens(
        get = { whole -> whole.actions },
        set = { { it } }
      )}


/**
 * Autogenerated Lens.
 * Read and manipulate [Application.processes]
 */
@ReadWrite
public val processes: Lens<Application, Processes> by lazy {
      Lens(
        get = { whole -> whole.processes },
        set = { part -> { whole -> whole.copy(processes = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.processes]
 */
@ReadWrite
public fun Application.processes(`set`: Processes.() -> Processes): Application = copy(processes =
    set(processes))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.deviceData]
 */
@ReadWrite
public val deviceData: Lens<Application, Device> by lazy {
      Lens(
        get = { whole -> whole.deviceData },
        set = { part -> { whole -> whole.copy(deviceData = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.deviceData]
 */
@ReadWrite
public fun Application.deviceData(`set`: Device.() -> Device): Application = copy(deviceData =
    set(deviceData))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.modals]
 */
@ReadWrite
public val modals: Lens<Application, Modals<Int>> by lazy {
      Lens(
        get = { whole -> whole.modals },
        set = { part -> { whole -> whole.copy(modals = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.modals]
 */
@ReadWrite
public fun Application.modals(`set`: Modals<Int>.() -> Modals<Int>): Application = copy(modals =
    set(modals))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.i18N]
 */
@ReadWrite
public val i18N: Lens<Application, I18N> by lazy {
      Lens(
        get = { whole -> whole.i18N },
        set = { part -> { whole -> whole.copy(i18N = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.i18N]
 */
@ReadWrite
public fun Application.i18N(`set`: I18N.() -> I18N): Application = copy(i18N = set(i18N))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.context]
 */
@ReadWrite
public val context: Lens<Application, Context> by lazy {
      Lens(
        get = { whole -> whole.context },
        set = { part -> { whole -> whole.copy(context = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.context]
 */
@ReadWrite
public fun Application.context(`set`: Context.() -> Context): Application = copy(context =
    set(context))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.uiStates]
 */
@ReadWrite
public val uiStates: Lens<Application, UiStates> by lazy {
      Lens(
        get = { whole -> whole.uiStates },
        set = { part -> { whole -> whole.copy(uiStates = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.uiStates]
 */
@ReadWrite
public fun Application.uiStates(`set`: UiStates.() -> UiStates): Application = copy(uiStates =
    set(uiStates))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.cookieDisclaimer]
 */
@ReadWrite
public val cookieDisclaimer: Lens<Application, CookieDisclaimer> by lazy {
      Lens(
        get = { whole -> whole.cookieDisclaimer },
        set = { part -> { whole -> whole.copy(cookieDisclaimer = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.cookieDisclaimer]
 */
@ReadWrite
public fun Application.cookieDisclaimer(`set`: CookieDisclaimer.() -> CookieDisclaimer): Application
    = copy(cookieDisclaimer = set(cookieDisclaimer))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.auctions]
 */
@ReadWrite
public val auctions: Lens<Application, List<Auction>> by lazy {
      Lens(
        get = { whole -> whole.auctions },
        set = { part -> { whole -> whole.copy(auctions = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.auctions]
 */
@ReadWrite
public fun Application.auctions(`set`: List<Auction>.() -> List<Auction>): Application =
    copy(auctions = set(auctions))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.bidRounds]
 */
@ReadWrite
public val bidRounds: Lens<Application, List<BidRound>> by lazy {
      Lens(
        get = { whole -> whole.bidRounds },
        set = { part -> { whole -> whole.copy(bidRounds = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.bidRounds]
 */
@ReadWrite
public fun Application.bidRounds(`set`: List<BidRound>.() -> List<BidRound>): Application =
    copy(bidRounds = set(bidRounds))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.bidderMailAddresses]
 */
@ReadWrite
public val bidderMailAddresses: Lens<Application, BidderMails> by lazy {
      Lens(
        get = { whole -> whole.bidderMailAddresses },
        set = { part -> { whole -> whole.copy(bidderMailAddresses = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.bidderMailAddresses]
 */
@ReadWrite
public fun Application.bidderMailAddresses(`set`: BidderMails.() -> BidderMails): Application =
    copy(bidderMailAddresses = set(bidderMailAddresses))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.shareSubscriptions]
 */
@ReadWrite
public val shareSubscriptions: Lens<Application, List<ShareSubscription>> by lazy {
      Lens(
        get = { whole -> whole.shareSubscriptions },
        set = { part -> { whole -> whole.copy(shareSubscriptions = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.shareSubscriptions]
 */
@ReadWrite
public
    fun Application.shareSubscriptions(`set`: List<ShareSubscription>.() -> List<ShareSubscription>):
    Application = copy(shareSubscriptions = set(shareSubscriptions))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.shareOffers]
 */
@ReadWrite
public val shareOffers: Lens<Application, List<ShareOffer>> by lazy {
      Lens(
        get = { whole -> whole.shareOffers },
        set = { part -> { whole -> whole.copy(shareOffers = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.shareOffers]
 */
@ReadWrite
public fun Application.shareOffers(`set`: List<ShareOffer>.() -> List<ShareOffer>): Application =
    copy(shareOffers = set(shareOffers))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.shareTypes]
 */
@ReadWrite
public val shareTypes: Lens<Application, List<ShareType>> by lazy {
      Lens(
        get = { whole -> whole.shareTypes },
        set = { part -> { whole -> whole.copy(shareTypes = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.shareTypes]
 */
@ReadWrite
public fun Application.shareTypes(`set`: List<ShareType>.() -> List<ShareType>): Application =
    copy(shareTypes = set(shareTypes))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.personalShareSubscriptions]
 */
@ReadWrite
public val personalShareSubscriptions: Lens<Application, List<ShareSubscription>> by lazy {
      Lens(
        get = { whole -> whole.personalShareSubscriptions },
        set = { part -> { whole -> whole.copy(personalShareSubscriptions = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.personalShareSubscriptions]
 */
@ReadWrite
public
    fun Application.personalShareSubscriptions(`set`: List<ShareSubscription>.() -> List<ShareSubscription>):
    Application = copy(personalShareSubscriptions = set(personalShareSubscriptions))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.personalShareOffers]
 */
@ReadWrite
public val personalShareOffers: Lens<Application, List<ShareOffer>> by lazy {
      Lens(
        get = { whole -> whole.personalShareOffers },
        set = { part -> { whole -> whole.copy(personalShareOffers = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.personalShareOffers]
 */
@ReadWrite
public fun Application.personalShareOffers(`set`: List<ShareOffer>.() -> List<ShareOffer>):
    Application = copy(personalShareOffers = set(personalShareOffers))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.shareSubscriptionStatusHistories]
 */
@ReadWrite
public val shareSubscriptionStatusHistories: Lens<Application, ShareSubscriptionStatusHistories> by
    lazy {
      Lens(
        get = { whole -> whole.shareSubscriptionStatusHistories },
        set = { part -> { whole -> whole.copy(shareSubscriptionStatusHistories = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.shareSubscriptionStatusHistories]
 */
@ReadWrite
public
    fun Application.shareSubscriptionStatusHistories(`set`: ShareSubscriptionStatusHistories.() -> ShareSubscriptionStatusHistories):
    Application = copy(shareSubscriptionStatusHistories = set(shareSubscriptionStatusHistories))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.distributionPoints]
 */
@ReadWrite
public val distributionPoints: Lens<Application, List<DistributionPoint>> by lazy {
      Lens(
        get = { whole -> whole.distributionPoints },
        set = { part -> { whole -> whole.copy(distributionPoints = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.distributionPoints]
 */
@ReadWrite
public
    fun Application.distributionPoints(`set`: List<DistributionPoint>.() -> List<DistributionPoint>):
    Application = copy(distributionPoints = set(distributionPoints))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.personalDistributionPoints]
 */
@ReadWrite
public val personalDistributionPoints: Lens<Application, List<DistributionPoint>> by lazy {
      Lens(
        get = { whole -> whole.personalDistributionPoints },
        set = { part -> { whole -> whole.copy(personalDistributionPoints = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.personalDistributionPoints]
 */
@ReadWrite
public
    fun Application.personalDistributionPoints(`set`: List<DistributionPoint>.() -> List<DistributionPoint>):
    Application = copy(personalDistributionPoints = set(personalDistributionPoints))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.bankAccounts]
 */
@ReadWrite
public val bankAccounts: Lens<Application, List<BankAccount>> by lazy {
      Lens(
        get = { whole -> whole.bankAccounts },
        set = { part -> { whole -> whole.copy(bankAccounts = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.bankAccounts]
 */
@ReadWrite
public fun Application.bankAccounts(`set`: List<BankAccount>.() -> List<BankAccount>): Application =
    copy(bankAccounts = set(bankAccounts))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.fiscalYears]
 */
@ReadWrite
public val fiscalYears: Lens<Application, List<FiscalYear>> by lazy {
      Lens(
        get = { whole -> whole.fiscalYears },
        set = { part -> { whole -> whole.copy(fiscalYears = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.fiscalYears]
 */
@ReadWrite
public fun Application.fiscalYears(`set`: List<FiscalYear>.() -> List<FiscalYear>): Application =
    copy(fiscalYears = set(fiscalYears))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.legalEntity]
 */
@ReadWrite
public val legalEntity: Lens<Application, LegalEntity> by lazy {
      Lens(
        get = { whole -> whole.legalEntity },
        set = { part -> { whole -> whole.copy(legalEntity = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.legalEntity]
 */
@ReadWrite
public fun Application.legalEntity(`set`: LegalEntity.() -> LegalEntity): Application =
    copy(legalEntity = set(legalEntity))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.creditorIdentifier]
 */
@ReadWrite
public val creditorIdentifier: Lens<Application, CreditorIdentifier?> by lazy {
      Lens(
        get = { whole -> whole.creditorIdentifier },
        set = { part -> { whole -> whole.copy(creditorIdentifier = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.creditorIdentifier]
 */
@ReadWrite
public fun Application.creditorIdentifier(`set`: CreditorIdentifier?.() -> CreditorIdentifier?):
    Application = copy(creditorIdentifier = set(creditorIdentifier))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.sepaModule]
 */
@ReadWrite
public val sepaModule: Lens<Application, SepaModule> by lazy {
      Lens(
        get = { whole -> whole.sepaModule },
        set = { part -> { whole -> whole.copy(sepaModule = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.sepaModule]
 */
@ReadWrite
public fun Application.sepaModule(`set`: SepaModule.() -> SepaModule): Application = copy(sepaModule
    = set(sepaModule))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.userData]
 */
@ReadWrite
public val userData: Lens<Application, User> by lazy {
      Lens(
        get = { whole -> whole.userData },
        set = { part -> { whole -> whole.copy(userData = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.userData]
 */
@ReadWrite
public fun Application.userData(`set`: User.() -> User): Application = copy(userData =
    set(userData))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.managedUsers]
 */
@ReadWrite
public val managedUsers: Lens<Application, List<ManagedUser>> by lazy {
      Lens(
        get = { whole -> whole.managedUsers },
        set = { part -> { whole -> whole.copy(managedUsers = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.managedUsers]
 */
@ReadWrite
public fun Application.managedUsers(`set`: List<ManagedUser>.() -> List<ManagedUser>): Application =
    copy(managedUsers = set(managedUsers))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.availablePermissions]
 */
@ReadWrite
public val availablePermissions: Lens<Application, Permissions> by lazy {
      Lens(
        get = { whole -> whole.availablePermissions },
        set = { part -> { whole -> whole.copy(availablePermissions = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.availablePermissions]
 */
@ReadWrite
public fun Application.availablePermissions(`set`: Permissions.() -> Permissions): Application =
    copy(availablePermissions = set(availablePermissions))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.availableApplications]
 */
@ReadWrite
public val availableApplications:
    Lens<Application, List<org.solyton.solawi.bid.module.application.`data`.application.Application>>
    by lazy {
      Lens(
        get = { whole -> whole.availableApplications },
        set = { part -> { whole -> whole.copy(availableApplications = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.availableApplications]
 */
@ReadWrite
public
    fun Application.availableApplications(`set`: List<org.solyton.solawi.bid.module.application.`data`.application.Application>.() -> List<org.solyton.solawi.bid.module.application.`data`.application.Application>):
    Application = copy(availableApplications = set(availableApplications))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.personalApplications]
 */
@ReadWrite
public val personalApplications:
    Lens<Application, List<org.solyton.solawi.bid.module.application.`data`.application.Application>>
    by lazy {
      Lens(
        get = { whole -> whole.personalApplications },
        set = { part -> { whole -> whole.copy(personalApplications = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.personalApplications]
 */
@ReadWrite
public
    fun Application.personalApplications(`set`: List<org.solyton.solawi.bid.module.application.`data`.application.Application>.() -> List<org.solyton.solawi.bid.module.application.`data`.application.Application>):
    Application = copy(personalApplications = set(personalApplications))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.personalApplicationContextRelations]
 */
@ReadWrite
public val personalApplicationContextRelations: Lens<Application, List<ContextRelation>> by lazy {
      Lens(
        get = { whole -> whole.personalApplicationContextRelations },
        set = { part -> { whole -> whole.copy(personalApplicationContextRelations = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.personalApplicationContextRelations]
 */
@ReadWrite
public
    fun Application.personalApplicationContextRelations(`set`: List<ContextRelation>.() -> List<ContextRelation>):
    Application = copy(personalApplicationContextRelations =
    set(personalApplicationContextRelations))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.personalModuleContextRelations]
 */
@ReadWrite
public val personalModuleContextRelations: Lens<Application, List<ContextRelation>> by lazy {
      Lens(
        get = { whole -> whole.personalModuleContextRelations },
        set = { part -> { whole -> whole.copy(personalModuleContextRelations = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.personalModuleContextRelations]
 */
@ReadWrite
public
    fun Application.personalModuleContextRelations(`set`: List<ContextRelation>.() -> List<ContextRelation>):
    Application = copy(personalModuleContextRelations = set(personalModuleContextRelations))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.userApplications]
 */
@ReadWrite
public val userApplications: Lens<Application, List<UserApplications>> by lazy {
      Lens(
        get = { whole -> whole.userApplications },
        set = { part -> { whole -> whole.copy(userApplications = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.userApplications]
 */
@ReadWrite
public fun Application.userApplications(`set`: List<UserApplications>.() -> List<UserApplications>):
    Application = copy(userApplications = set(userApplications))

/**
 * Autogenerated Lens.
 * Read and manipulate [Application.applicationOrganizationRelations]
 */
@ReadWrite
public val applicationOrganizationRelations:
    Lens<Application, List<ApplicationOrganizationRelation>> by lazy {
      Lens(
        get = { whole -> whole.applicationOrganizationRelations },
        set = { part -> { whole -> whole.copy(applicationOrganizationRelations = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [Application.applicationOrganizationRelations]
 */
@ReadWrite
public
    fun Application.applicationOrganizationRelations(`set`: List<ApplicationOrganizationRelation>.() -> List<ApplicationOrganizationRelation>):
    Application = copy(applicationOrganizationRelations = set(applicationOrganizationRelations))
